jQuery(document).ready(function($) {
  $(window).on('scroll', function () {
      120 <= $(window).scrollTop() ? $("nav.scrolled").addClass("shrink") : $("nav.scrolled").removeClass("shrink");
  });

  $(".navbar .hamburger").click(function () {
      $(this).toggleClass("is-active");
  });

  $("img.svg").each(function () {
      var e = $(this),
          l = e.attr("id"),
          t = e.attr("class"),
          a = e.attr("src");
      $.get(
          a,
          function (a) {
              var s = $(a).find("svg");
              void 0 !== l && (s = s.attr("id", l)),
                  void 0 !== t && (s = s.attr("class", t + " replaced-svg")),
                  !(s = s.removeAttr("xmlns:a")).attr("viewBox") && s.attr("height") && s.attr("width") && s.attr("viewBox", "0 0 " + s.attr("height") + " " + s.attr("width")),
                  e.replaceWith(s);
          },
          "xml"
      );
  });

  $(".slick-home").slick({
    dots: !0, 
    infinite: !0, 
    speed: 400, 
    autoplay: !0, 
    autoplaySpeed: 4e3, 
    arrows: !0, 
    slidesToShow: 1, 
    slidesToScroll: 1, 
    fade: !0, 
    responsive: [{ 
      breakpoint: 768, 
      settings: { 
        arrows: !1 
      } 
    }] 
  });
  $(".wpcf7 br").remove(),
  $(".page_brands .brands_subcategories li a").each(function () {
      var a = $(this).attr("data-letter");
      $('.page_brands .brands_subcategories li a[data-letter="' + a + '"]').each(function () {
          $(this).appendTo(i('.page_brands .inner div[data-letter="' + a + '"]'));
      });
  }),
  $(".woocommerce-account .input-text").addClass("form-control"),
  $(".woocommerce-checkout .input-text").addClass("form-control"),
  $(".woocommerce-checkout .input-text").each(function () {
      i(this).prev(i("abbr").remove());
      i(this).prev().html();
  }),
  $("#order_comments_field #order_comments").attr("placeholder", "Adres lub numer paczkomatu"),
  $("footer ul.menu li a").prepend("<span>&raquo;</span>"),
  $(".page_sell .info_row:nth-child(even)").each(function () {
      i('.page_sell .info_row:nth-child(even) [class*="col-"]:nth-child(1)').addClass("col-sm-push-10"), i('.page_sell .info_row:nth-child(even) [class*="col-"]:nth-child(3)').addClass("col-sm-pull-10");
  }),
  $(".page_faq .panel-group .panel:first-child() .panel-collapse").addClass("in"),
  $(".page_faq .panel-group .panel:first-child() .panel-heading a").removeClass("collapsed"),
  $(".widget select").wrap('<div class="select_wrapper"></div>'),
  $(".page_sell .wpcf7 #additionalSell").click(function () {
      $(this).hasClass("click3")
          ? ($(this).addClass("disabled"), $("#sellItem5").css("display", "block"))
          : $(this).hasClass("click2")
          ? ($(this).addClass("click3"), $("#sellItem4").css("display", "block"))
          : $(this).hasClass("click1") && ($(this).addClass("click2"), $("#sellItem3").css("display", "block")),
          $(this).addClass("click1"),
          $("#sellItem2").css("display", "block");
  });

  $('.paypo-baner').on('click', function() {
      $('.paypo').fadeIn('slow');
  });

  $('.paypo__close, .paypo').on('click', function() {
      $('.paypo').fadeOut('slow');
  });

  var childMenu = $(".top-navigation .menu-item-has-children > a");
    childMenu.append("<span class='mobile-menu-arrow'></span>");
    $('.mobile-menu-arrow').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('mobile-menu-arrow--active');
    $(this).parent().next().slideToggle('medium');
    $(this).parent().toggleClass('active');
    });

    if ( $('.product_thumb .product__video').length > 0 ) {
        $('.product_thumb .product__video').each(function() {
            var thumbHeight = $('.product_thumb .product_thumb-img').height();
            $(this).css('maxHeight', thumbHeight+'px');
        })
    }

    if ( $('.product_thumb_archive .product__video').length > 0 ) {
        $('.product_thumb_archive .product__video').each(function() {
            var thumbHeight = $('.product_thumb_archive .attachment-woocommerce_thumbnail').height();
            $(this).css('maxHeight', thumbHeight+'px');
        })
    }

});